import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from '../../../app.component';
import { CategoriaPlanoService } from '../../../core/services/categoria_plano.service';
import { CupomService } from '../../../core/services/cupom.service';
import { PropostaService } from '../../../core/services/proposta.service';
import { CepService } from '../../../core/services/cep.service';
import { ICarrinho } from '../../../shared/interfaces/carrinho.interface';
import { Meta, Title } from '@angular/platform-browser';
import { ProdutoService } from '../../../core/services/produto.service';
import { PropostaComponent } from '../proposta';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TYPE_META } from '../../../core/constants/meta_title.constant';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ISlideMenu } from '../../../shared/components/slide-menu/slide-menu.interface';
import { ICart } from '../../../shared/interfaces/cart.interface';
import { ProductService } from '../../../core/services/product.service';
import { COUNT_DIARIAS_DEFAULT, COUNT_MAX_DIARIAS_DEFAULT } from '../../../app.constants';
import { RdService } from '../../../core/services/rd.service';

@Component({
    selector: 'app-checkin',
    templateUrl: './checkin.component.html',
    styleUrls: ['./checkin.component.sass']
})
export class CheckinComponent extends PropostaComponent implements OnInit {

    public form: FormGroup;
    public slideMenu: ISlideMenu = {
        itemActive: 'Plano',
        item: 'Dados Pessoais',
        subItem: 'Pagamento'
    };
    public cart: ICart = this.defaultCart();
    public minDaily = COUNT_DIARIAS_DEFAULT;
    public maxDaily = COUNT_MAX_DIARIAS_DEFAULT;
    public diaries: Array<{value: number}> = [];
    public submit = false;

    termsOfUseAccepted = false;

    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public cepService: CepService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public route: ActivatedRoute,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public productService: ProductService,
        public deviceService: DeviceDetectorService,
        public rdService: RdService,
        formBuilder: FormBuilder
    ) {
        super(injector);

        for(let i = this.minDaily; i <= this.maxDaily; i++) {
            this.diaries.push({value: i});
        }

        this.form = formBuilder.group({
            name: new FormControl( '', [Validators.required]),
            email: new FormControl( '', [Validators.required, Validators.email]),
            mobile: new FormControl( '', [Validators.required]),
            dailyCounter: new FormControl({ value: this.minDaily, disabled: true }, [Validators.required]),
            selectedCategory: new FormControl('08', [Validators.required]),
            selectedTypeValue: new FormControl('2', [Validators.required]),
        })
    }

    async ngOnInit() {
        this.route.queryParams.subscribe(params => this.params = params);
        await this.inOnInit();
        this.setMetaTitle(TYPE_META.CARRINHO.FACA_PARTE);
        await this.initCart();
        this.formInit(this.cart);
    }

    async initCart() {
        if (!this.carrinhos) {
            this.carrinhos = [this.defaultCarrinho()];
        }
        this.form.controls.dailyCounter.setValue({ value: this.form.controls.dailyCounter.value, disabled: true });
        if(this.isMobile) {
            this.form.controls.dailyCounter.enable();
        }
        await this.calcularValoresFacilita();
        this.cart = this.transformCart();
    }

    formInit(cart: ICart) {
        this.form.controls.selectedCategory.setValue(cart.selectedCategory);
        this.form.controls.dailyCounter.setValue(cart.dailyCounter);
        this.form.controls.selectedTypeValue.setValue(cart.selectedTypeValue);
    }

    async lessDailyList() {
        if(this.form.controls.dailyCounter.value <= this.minDaily) {
            return;
        }
        this.form.controls.dailyCounter.setValue(this.form.controls.dailyCounter.value - 1);
        await this.calculateCart({
            selectedCategory: this.form.controls.selectedCategory.value,
            dailyCounter: this.form.controls.dailyCounter.value,
            selectedTypeValue: this.form.controls.selectedTypeValue.value,
        });
    }

    async onChangeLessDailyList() {
        await this.calculateCart({
            selectedCategory: this.form.controls.selectedCategory.value,
            dailyCounter: this.form.controls.dailyCounter.value,
            selectedTypeValue: this.form.controls.selectedTypeValue.value,
        });
    }

    async moreDailyList() {
        if(this.form.controls.dailyCounter.value >= this.maxDaily) {
            return;
        }
        this.form.controls.dailyCounter.setValue(this.form.controls.dailyCounter.value + 1);
        await this.calculateCart({
            selectedCategory: this.form.controls.selectedCategory.value,
            dailyCounter: this.form.controls.dailyCounter.value,
            selectedTypeValue: this.form.controls.selectedTypeValue.value,
        });
    }

    async onChangeCategoryList() {
        this.cart.plans = (this.cart.selectedTypeValue === 2)
            ? this.productService.transformInPlans(this.planosDuplos)
            : this.productService.transformInPlans(this.planosTriplos);
        this.cart.selectedCategory = this.form.controls.selectedCategory.value;
        this.cart.categoryTitle = this.getCategoryTitleByCode(this.cart.selectedCategory);
        if(this.cart.categoryTitle === 'Básico') {
            this.cart.dailyCounter = 7;
        } else {
            this.cart.dailyCounter = this.minDaily;
        }
        await this.calculateCart({
            selectedCategory: this.form.controls.selectedCategory.value,
            dailyCounter: this.form.controls.dailyCounter.value,
            selectedTypeValue: this.form.controls.selectedTypeValue.value,
        });
    }

    async onChangeTypeList() {
        this.form.controls.selectedCategory.setValue(this.productService.transitionTypeByCategoryCode(this.form.controls.selectedCategory.value));
        await this.calculateCart({
            selectedCategory: this.form.controls.selectedCategory.value,
            dailyCounter: this.form.controls.dailyCounter.value,
            selectedTypeValue: this.form.controls.selectedTypeValue.value,
        });

    }


    getErrorMessage(field: string) {
        if(!this.submit) {
            return '';
        }
        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
                        input.hasError('email') ? 'E-mail inválido.' :
                            '';
    }

    showError(field: string) {
        return this.form.controls[field].errors && !this.form.controls[field].pristine;
    }

    mobileDiaries(cart: ICart) {
        if (cart.selectedCategory === '05' || cart.selectedCategory === '80') {
            return this.diaries.filter(item => item.value >= 7 );
        }
        return this.diaries;
    }

    onCartChange(data: any) {
        this.carrinhos = data;
    }

    termsOfUseAcceptedEmit(event: boolean) {
        this.termsOfUseAccepted = event;
    }

    isFormValid() {
        return this.termsOfUseAccepted && this.form.valid;
    }

    async onSubmit() {
        if (this.totalDiarias > 28) {
            this.toast.error('A quantidade de diárias não pode exceder 28!', '', { timeOut: 5000});
            return;
        }

        if (!!this.cupomSales) {
            this.cupom = this.cupom === '' ? this.cupomSales.cupom : this.cupom;
            this.isCupomValido = this.isCupomNotExpirate(this.cupomSales.validate);
            await this.calcularValoresFacilita();
        }

        this.submit = true;
        if(this.form.valid) {
            this.appComponent.showOverlay();
            const result = {
                ...this.propostaResult,
                email: this.form.value.email,
                mobile: this.form.value.mobile,
                name: this.form.value.name,
            }

            localStorage.setItem('mtl.proposta', JSON.stringify(result));
            await this.clientValidate(this.form.value.email, 'EMAIL');
            await this.rdService.cartPartOne(this.form.value.name, this.form.value.mobile, this.form.value.email, this.carrinhos[0]);
            this.appComponent.hideOverlay();
        }

    }

    private defaultCart(): ICart {
        return {
            id: 0,
            title: '',
            text1: '',
            text2: '',
            plans: [],
            dailyCounter: 0,
            monthlyValue: 0,
            categoryTitle: '',
            selectedCategory: '',
            selectedTypeValue: 0,
            formattedMonthlyValue: ''
        };
    }

    private transformCart() {
        const carrinho = this.carrinhos[0];
        const cart: ICart = this.defaultCart();
        if(!carrinho) {
            return cart;
        }
        cart.id = carrinho.id;
        cart.title = carrinho.titulo;
        cart.text1 = carrinho.text1;
        cart.text2 = carrinho.text2;
        cart.monthlyValue = carrinho.valorMensal;
        cart.formattedMonthlyValue = carrinho.valorMensalString;
        cart.categoryTitle = carrinho.categoriaTitulo;
        cart.selectedCategory = carrinho.selectedCategoria;
        cart.dailyCounter = carrinho.countDiarias;
        cart.selectedTypeValue = carrinho.selectedTypeValue;
        cart.plans =  this.productService.transformInPlans(carrinho.planos);
        return cart;
    }

    private transformCarrinho() {
        this.carrinhos = [{
            id: this.cart.id,
            titulo: this.cart.title,
            categoriaTitulo: this.cart.categoryTitle,
            countDiarias: this.cart.dailyCounter,
            last: true,
            selectedCategoria: this.cart.selectedCategory,
            selectedTypeValue: this.cart.selectedTypeValue,
            text1: this.cart.text1,
            text2: this.cart.text2,
            valorMensalString: this.cart.formattedMonthlyValue,
            valorMensal: this.cart.monthlyValue,
            totalDiarias: this.cart.dailyCounter,
            totalValorMensal: this.cart.formattedMonthlyValue,
            planos: this.productService.transformInPlanos(this.cart.plans),
        }]
    }

    private async calculateCart({selectedCategory, dailyCounter, selectedTypeValue }: {selectedCategory: string, dailyCounter: number, selectedTypeValue: number}) {
        this.cart.selectedCategory = selectedCategory;
        this.cart.dailyCounter = dailyCounter;
        this.cart.selectedTypeValue = selectedTypeValue;
        this.transformCarrinho();
        await this.calcularValoresFacilita();
        this.cart = this.transformCart();
    }

    private getCategoryTitleByCode(code: string) {
        const plans = this.planosAll.filter(item => item.codigoCategoria === code);
        if(plans.length === 1) {
            return plans[0].descricao.trim();
        }
        return '';
    }

    defaultCarrinho(id: number = 0, noText: boolean = false): ICarrinho {
        let titulo = '';
        if (!this.carrinhos) {
            titulo = this.getCategoryTitleByCode(this.selectedCategoria);
            titulo = titulo.replace('Triplo', '');
            this.totalDiarias = this.countDiarias;
            return {
                id,
                titulo,
                text1: (noText) ? null : this.text1,
                text2: (noText) ? null : this.text2,
                valorMensalString: this.valorMensal,
                valorMensal: this.valorMensal,
                categoriaTitulo: this.getCategoryTitleByCode(this.selectedCategoria),
                selectedCategoria: this.selectedCategoria,
                countDiarias: this.countDiarias,
                totalDiarias: null,
                totalValorMensal: null,
                selectedTypeValue: this.selectedTypeValue,
                planos: this.planos,
                last: true,
            };
        }
        titulo = this.getCategoryTitleByCode(this.carrinhos[0].selectedCategoria);
        titulo = titulo.replace('Triplo', '');
        let countDiarias = 28 - this.totalDiarias;
        if (this.totalDiarias <= 21) {
            countDiarias = 7;
        }
        return {
            id,
            titulo,
            text1: (noText) ? null : this.carrinhos[0].text1,
            text2: (noText) ? null : this.carrinhos[0].text2,
            valorMensalString: this.carrinhos[0].valorMensalString,
            valorMensal: this.carrinhos[0].valorMensal,
            categoriaTitulo: this.getCategoryTitleByCode(this.carrinhos[0].selectedCategoria),
            selectedCategoria: this.carrinhos[0].selectedCategoria,
            countDiarias ,
            totalDiarias: null,
            totalValorMensal: null,
            selectedTypeValue: this.carrinhos[0].selectedTypeValue,
            planos: this.carrinhos[0].planos,
            last: true,
        };

    }

    async cadastrarNoClube(): Promise<void> {
        if (this.totalDiarias > 28) {
            this.toast.error('A quantidade de diárias não pode exceder 28!', '', { timeOut: 5000});
            return;
        }
        this.cupomSales = this.getCupomStorage();
        if (!!this.cupomSales) {
            this.cupom = this.cupom === '' ? this.cupomSales.cupom : this.cupom;
            this.isCupomValido = this.isCupomNotExpirate(this.cupomSales.validate);
            await this.calcularValoresFacilita();
        }
        localStorage.setItem('mtl.proposta', JSON.stringify(this.propostaResult));
        await this.router.navigate(['exclusividade']);
    }

}
